<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Información de Lapifan</p>
      <button
          type="button"
          class="delete"
          @click="$parent.close()"/>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <b-tabs>
          <b-tab-item label="Información de membresía">
            <div class="columns is-multiline">
              <div class="column is-12">
                <ul>
                  <li><strong>Paciente: </strong>{{patient.full_name}}</li>
                  <li><strong>No. Membresía: </strong>{{patient.lapifan_active.item.code}}</li>
                  <li><strong>Fecha de caducidad: </strong>{{vigencyAt}}</li>
                  <li><strong>Estatus: </strong>{{vigente ? 'Vigente' : 'No vigente'}}</li>
                </ul>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Correos enviados">
            <b-loading
              :is-full-page="false"
              v-model="isLoading"
              :can-cancel="true"
            ></b-loading>
            <table class="table is-bordered is-striped is-narrow is-hoverable">
              <thead>
              <tr>
                <th>Fecha</th>
                <th>Status</th>
                <th>Destinatario</th>
                <th>Asunto</th>
                <th>Leido</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in data">
                <td>{{item.timestamp}}</td>
                <td>{{item.payload ? item.payload.notificationType : ''}}</td>
                <td>{{item.payload && item.payload.mail && Array.isArray(item.payload.mail.destination)? item.payload.mail.destination.join(',') : ''}}</td>
                <td>{{item.payload && item.payload.mail && item.payload.mail.commonHeaders ? item.payload.mail.commonHeaders.subject : ''}}</td>
                <td>{{item.readAt}}</td>
              </tr>
              </tbody>
            </table>
          </b-tab-item>
        </b-tabs>
      </div>
    </section>
    <footer class="modal-card-foot">
      <b-button native-type="button" type="is-primary" @click="$parent.close()">Cerrar</b-button>
      <b-button native-type="button" type="is-default" @click="onSendWelcomeMail">Reenviar correo de bienvenida</b-button>
    </footer>
  </div>
</template>

<script>

export default {
  name: "LapifanModal",
  props: {
    patient: Object
  },
  data() {
    return {
      data: [],
      apiUrl: 'tracking-emails-lapifan',
      isLoading: false,
    }
  },
  computed: {
    vigencyAt() {
      return this.$alfalab.lapifanVigencyAt(this.patient.lapifan_active);
    },
    vigente() {
      return this.$alfalab.lapifanIsVigente(this.patient.lapifan_active);
    }
  },
  mounted() {
    //console.log('cargando emails');
    if(this.patient.lapifan_active.item.code){
      this.prepareData();
    }
  },
  methods: {
    onSendWelcomeMail(){
      const id = this.patient.lapifan_active.item.id
      this.$loader.show();
      this.$http.post(`/lapifan/mail/${id}`).then(() => {
        this.$toast.success('Correo enviado con éxito');
      }).finally(() => {
        this.$loader.hide();
      })
    },
    prepareData() {
      this.isLoading = true;
      this.$http.get(`${this.apiUrl}/${this.patient.lapifan_active.item.code}`).then(({data}) => {
        this.data = data.data.sesEvents.events || [];
      }).catch(() => {

      }).finally(() => {
        this.isLoading = false;
      })
    }
  }
}

</script>


<style scoped>

</style>